
const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-4 col-sm-4 contact-info">
            <div className="contact-item">
              <h3>Contact in the UK</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data.contact ? props.data.contact.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data.contact ? props.data.contact.phone : ""}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data.contact ? props.data.contact.email : ""}
              </p>
            </div>
          </div>
          <div className="col-md-4 col-sm-4 contact-info">
            <div className="contact-item">
              <h3>Монгол дахь хаяг</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Хаяг
                </span>
                {props.data.contactMongolia ? props.data.contactMongolia.address : ""}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Утасны дугаар
                </span>{" "}
                {props.data.contactMongolia ? props.data.contactMongolia.phone : ""}
              </p>
            </div>
          </div>
          <div className="col-md-3 col-sm-3 col-md-offset-1 col-sm-offset-1">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a target="_blank" href={props.data?.contact ? props.data.contact.facebook : "/"} rel="noreferrer">
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://www.instagram.com/tomkoapp/" rel="noreferrer">
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
              {/* <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Send Message
                </button>
              </form> */}
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p> © {new Date().getFullYear()} Gobicraft Systems
          </p>
        </div>
      </div>
    </div>
  );
};
